import React, { useState } from 'react';
import styles from './style.module.scss';

const AddressTable = ({ data, onEdit, onEditFullAddress }) => {
  const [selectedAddresses, setSelectedAddresses] = useState({});

  const handleSelectAddress = (itemId, addressItem) => {
    setSelectedAddresses(prev => ({
      ...prev,
      [itemId]: addressItem.id,
    }));
    onEditFullAddress(itemId, addressItem.address);
  };

  return (
    <div>
      <table className={styles.tableContainer}>
        <thead>
          <tr>
            <th>ШПИ (ID)</th>
            <th>Region</th>
            <th>Full Address</th>
            <th>Address</th>
            <th>Edit</th>
          </tr>
        </thead>
        <tbody>
          {data.map(item => (
            <tr key={item.id}>
              <td>{item.id}</td>
              <td>{item.region}</td>
              <td>{item.fullAddress}</td>
              <td>
                <select
                  className={styles.selectInput}
                  value={selectedAddresses[item.id] || ''}
                  onChange={e =>
                    handleSelectAddress(
                      item.id,
                      item.addressAtNpiList.find(
                        addressItem => addressItem.id === e.target.value,
                      ),
                    )
                  }>
                  <option value="" disabled>
                    Select Address
                  </option>
                  {item.addressAtNpiList?.map(addressItem => (
                    <option key={addressItem.id} value={addressItem.id}>
                      {addressItem.id} - {addressItem.address}
                    </option>
                  ))}
                </select>
              </td>
              <td>
                <button
                  type="button"
                  aria-hidden
                  className={styles.editButton}
                  onClick={() => onEdit(item.id)}>
                  Edit
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AddressTable;
